function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { offset } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
export default {
  name: buildComponentName('RateStar'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-rate-star'
    },
    index: {
      type: Number,
      default: 0
    },
    character: {
      type: Function,
      default: null
    },
    value: {
      type: Number,
      default: 0
    },
    allowHalf: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          allowHalf = this.allowHalf,
          index = this.index,
          value = this.value,
          focused = this.focused;
      var start = index;
      var end = index + 1;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-full"), end <= value), _defineProperty(_ref, "".concat(prefixCls, "-zero"), allowHalf && start >= value || !allowHalf && end > value), _defineProperty(_ref, "".concat(prefixCls, "-half ").concat(prefixCls, "-active"), allowHalf && value > start && value < end), _defineProperty(_ref, "".concat(prefixCls, "-focused"), focused && (value > start && value <= end || value === 0 && index === 0)), _ref;
    }
  },
  methods: {
    getStarValue: function getStarValue(el, posX) {
      var index = this.index,
          allowHalf = this.allowHalf;
      var value = index + 1;

      if (allowHalf) {
        var _offset = offset(el),
            left = _offset.left;

        var w = el.clientWidth;

        if (posX - left < w / 2) {
          value -= 0.5;
        }
      }

      return value;
    },
    onClick: function onClick(e) {
      var $el = this.$el,
          index = this.index,
          disabled = this.disabled,
          getStarValue = this.getStarValue;

      if (disabled) {
        return;
      }

      var value = getStarValue($el, e.pageX);
      this.$emit('click', e, {
        index: index,
        el: $el,
        value: value
      });
    },
    onHover: function onHover(e) {
      var $el = this.$el,
          index = this.index,
          disabled = this.disabled,
          getStarValue = this.getStarValue;

      if (disabled) {
        return;
      }

      var value = getStarValue($el, e.pageX);
      this.$emit('hover', e, {
        index: index,
        el: $el,
        value: value
      });
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        classes = this.classes,
        character = this.character,
        onClick = this.onClick,
        onHover = this.onHover;
    return h("li", {
      "class": classes,
      "on": {
        "click": onClick,
        "mousemove": onHover
      }
    }, [h("div", {
      "class": "".concat(prefixCls, "-first")
    }, [character()]), h("div", {
      "class": "".concat(prefixCls, "-second")
    }, [character()])]);
  }
};